export default "__VITE_ASSET__565210d4__"